export const UDYAM_REG_NUMBER = 'UDYAM-UK-06-0072325';


